/**
 * HTTP API origin with no trailing slash.
 * Empty string = same origin (dev server proxies /api via setupProxy.js).
 *
 * In development, we always use the proxy unless REACT_APP_DIRECT_API=true, so a stale
 * REACT_APP_BACKEND_URL (e.g. from .env.local or the OS) cannot force cross-origin
 * fetches to localhost:8000 and break with "Failed to fetch".
 */
export function getApiBase() {
  const v = process.env.REACT_APP_BACKEND_URL;
  const dev = process.env.NODE_ENV === 'development';
  const direct = process.env.REACT_APP_DIRECT_API === 'true';

  if (dev && !direct) {
    return '';
  }

  if (v == null || String(v).trim() === '' || v === 'proxy') {
    return '';
  }
  return String(v).replace(/\/$/, '');
}

/** HTTP(S) base for building WebSocket URLs (useWebSocket converts http→ws). */
export function getWebSocketHttpBase() {
  const base = getApiBase();
  if (base === '') {
    if (typeof window === 'undefined') return '';
    return `${window.location.protocol}//${window.location.host}`;
  }
  return base;
}
